import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { FhqTemplateState } from '@reducers/fhq-templates';

export const getFhqTemplates = (state: RootState): FhqTemplateState => state.fhqTemplates;
export const getFhqTemplatesData = createSelector(getFhqTemplates, (fhqTemplate) => fhqTemplate?.data);
export const isFhqTemplatesLoading = createSelector(getFhqTemplates, (fhqTemplate) => fhqTemplate?.loading);
